import { createStyles } from "@mantine/emotion";

export const useStylesUserProfileAccountSettings = createStyles((theme) => {
  return {
    wrap: {
      maxWidth: `calc(${theme.spacing.profile.width.label} + ${theme.spacing.profile.width.input} + 6rem)`,
      marginInline: "auto",
      ".button-mfa-action": {
        paddingRight: "0",
      },
      ".select-mfa-status-active": {
        marginLeft: "0",
      },
      ".select-mfa-status-inactive": {
        marginLeft: "0",
      },

      ".label-mfa-action": {
        whiteSpace: "nowrap",
      },
    },
    emailSection: {
      width: "100%",
      paddingTop: theme.margin.lg,
    },
    emailHeading: {
      fontSize: "1.5em",
      fontFamily: theme.headings.fontFamily.secondary,
      textAlign: "center",
      marginBottom: theme.margin.lg,
    },
    emailFields: {
      width: "100%",
      maxWidth: `calc(${theme.spacing.profile.width.label} + ${theme.spacing.profile.width.input})`,
      [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
        maxWidth: "calc(100% - 4rem)",
      },
    },
    emailMasterRow: {
      display: "grid",
      gridTemplateColumns: `${theme.spacing.profile.width.label} minmax(0, ${theme.spacing.profile.width.input}) auto`,
      alignItems: "start",
      [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
        gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr) 4rem",
      },
    },
    emailSave: {
      gridColumn: 3,
      gridRow: 1,
      paddingLeft: "20px",
      [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
        paddingLeft: "10px",
      },
    },
    emailRow: {
      display: "grid",
      gridTemplateColumns: `${theme.spacing.profile.width.label} minmax(0, 1fr)`,
      alignItems: "start",
      [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
        gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
      },
    },
    emailLabel: {
      gridColumn: 1,
      gridRow: "1 / span 2",
      paddingRight: theme.spacing.profile.padding.right,
      paddingTop: theme.spacing.xs,
      fontFamily: theme.headings.fontFamily.bold,
      fontSize: theme.spacing.profile.fontSize.label,
      textAlign: "right",
      [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
        textAlign: "left",
      },
    },
    emailControl: {
      gridColumn: 2,
      minWidth: 0,
    },
    emailLabelContent: {
      justifyContent: "flex-end",
      label: {
        whiteSpace: "nowrap",
      },
      [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
        justifyContent: "flex-start",
        flexWrap: "wrap",
        label: {
          minWidth: 0,
          whiteSpace: "normal",
          overflowWrap: "anywhere",
        },
      },
    },
    emailDetailsToggle: {
      alignSelf: "flex-end",
    },
    emailInput: {
      fontSize: theme.spacing.profile.fontSize.input,
      lineHeight: theme.spacing.profile.lineHeight.input,
      border: "1px solid rgba(112, 112, 112, 0.5019607843)",
    },
    emailActions: {
      display: "flex",
      justifyContent: "flex-end",
      flexWrap: "nowrap",
      gap: theme.spacing.xs,
      "& button": {
        minWidth: 0,
        height: "auto",
        minHeight: "2.25rem",
        paddingBlock: theme.spacing.xs,
      },
      "& .mantine-Button-label": {
        whiteSpace: "normal",
      },
    },
  };
});
